// extracted by mini-css-extract-plugin
export default {"error":"Message_error__4bsXO","success":"Message_success__KT7aC"};